import CheckBox from '../../../checkBox/checkBox';
import { VIDEO_SELFIE } from 'constants/identityMethod';
import React, { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { actions as formActions } from 'react-redux-form';
import { bindActionCreators } from 'redux';
import { FormattedText, formatText } from 'core/i18n';
import { getClauseByVideo } from './utils/getClauseByVideo';
import { TERMS_PDF, URL_PDF } from './constants';

const VideoClause = ({
    formActions,
    handleVideoClause,
    isAres,
    userProfile,
    userProfileForm,
    isBiometricDecisionActive,
    isSelectedVideoselfieWithBiometrics,
    storage,
}) => {
    const { videoSelected } = userProfile;

    const isVideoSelfieSelected = videoSelected === VIDEO_SELFIE;

    const clauseByVideo = videoSelected =>
        getClauseByVideo({
            videoSelected,
            isSelectedVideoselfieWithBiometrics,
            biometryDecisionActive: isBiometricDecisionActive,
        });
    const createClauseTextByVideo = videoSelected => (
        <FormattedText value={clauseByVideo(videoSelected)} injectedStrings={[URL_PDF + TERMS_PDF]} />
    );
    useEffect(() => {
        formActions.change(
            'userProfile.acceptedText',
            formatText(clauseByVideo(videoSelected), [URL_PDF + TERMS_PDF])?.replace(/<[^>]*>/g, '')
        );

        const identification = () => storage.get('identification') || {};
        const videoType = isVideoSelfieSelected ? 'videoSelfie' : 'videoCall';

        if (identification[videoType]) {
            formActions.change('userProfile.videoCallClause', identification[videoType]?.videoCallClause);
            formActions.change(
                'userProfile.agreeVideoCallClauseCheck',
                identification[videoType]?.agreeVideoCallClauseCheck
            );
        } else {
            formActions.change('userProfile.agreeVideoCallClauseCheck', false);
            formActions.change('userProfile.videoCallClause', false);
        }

        return () => {
            formActions.change('userProfile.grantedPermission', undefined);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [videoSelected, isSelectedVideoselfieWithBiometrics]);

    return (
        <div className="legal-check">
            <CheckBox
                profileModel="userProfile.videoCallClause"
                fieldsRequired="1"
                checkBoxList={[
                    {
                        label: createClauseTextByVideo(isAres ? VIDEO_SELFIE : userProfile.videoSelected),
                        model: 'userProfile.agreeVideoCallClauseCheck',
                        required: true,
                        onChange: handleVideoClause,
                        errorMessageComponent: <></>,
                    },
                ]}
                listClassName="agree-videoCall-clause"
                userProfile={userProfile}
                userProfileForm={userProfileForm}
                formActions={formActions}
            />
        </div>
    );
};

export default connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        immStepsState: state.steps,
        options: state.options,
        video: state.video,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
    })
)(VideoClause);
